import { Button, Dialog, DialogActions, DialogContent, MenuItem, TextField } from "@mui/material";
import DialogTitleWithCloseButton from "../../../components/DialogTitleWithCloseButton";
import { Component } from "react";
import { DEPARTMENT } from "../../../../../shared/constants";
import { errorToast } from "../../../toast";
import { hideLoading, showLoading } from "../../../loading";
import request from "../../../request";
import swal from "sweetalert";
import { returnChangedAttributes } from "../../../utils";
import AttachmentInput from "../../../components/AttachmentInput";


export default class Editor extends Component {

   state = {
      amount: '',
      purpose: '',
      department: '',
      quotation: null,
   }

   isEditMode = () => {
      return Boolean(this.props.data);
   }

   submit = async () => {

      // validate form
      const txtAmount = document.getElementById('txt-amount');
      const txtDepartment = document.getElementById('txt-department');
      const txtPurpose = document.getElementById('txt-purpose');

      const { department, purpose } = this.state;
      const amount = parseFloat(parseFloat(this.state.amount).toFixed(2));

      if (!amount) {
         errorToast('Amount is required');
         return txtAmount.focus();
      }

      if (!department) {
         errorToast('Department is required');
         return txtDepartment.focus();
      }

      if (!purpose) {
         errorToast('Purpose is required');
         return txtPurpose.focus();
      }

      // submit
      try {

         const { quotation } = this.state;
         let data = { amount, department, purpose };

         if (quotation) {
            const { name, ext, base64 } = quotation;
            data.quotation = { name, ext, base64 };
         }

         let url;
         let method;

         if (this.isEditMode()) {
            method = 'PATCH';
            url = `/api/finance/cash-requisitions/${this.props.data._id}`;

            data = returnChangedAttributes(data, this.props.data);

            if (!Object.keys(data).length)
               return errorToast('No changes made');

         } else {
            method = 'POST';
            url = '/api/general/cash-requisitions';
         }

         showLoading();

         const res = await request({ url, method, data });
         this.props.onClose(res.data);
         
         swal(
            'Success',
            `Cash requisition ${this.isEditMode() ? 'updated': 'submited' } successfully`,
            'success'
         );

      } catch (err) {
         swal("Error", err.message, "error");
      } finally {
         hideLoading();
      }

   }

   componentDidMount() {
      if (this.isEditMode()) {
         const { amount, department, purpose } = this.props.data;
         this.setState({ amount, department, purpose });
      }
   }

   render() {
      return <Dialog open>
         <DialogTitleWithCloseButton onClose={this.props.onClose}>
            Cash Requisition
         </DialogTitleWithCloseButton>

         <DialogContent dividers>
            <div className="w-[250px] max-w-full *:my-2">
               <TextField
                  id="txt-amount"
                  label="Amount"
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="number"
                  value={this.state.amount}
                  onChange={e => this.setState({ amount: e.target.value })}
               />
               <TextField
                  id="txt-department"
                  label="Department"
                  variant="outlined"
                  size="small"
                  fullWidth
                  select
                  value={this.state.department}
                  onChange={e => this.setState({ department: e.target.value })}
               >
                  {
                     Object
                        .values(DEPARTMENT)
                        .map(department => <MenuItem key={department} value={department}>
                           {department.toUpperCase()}
                        </MenuItem>)
                  }
               </TextField>
               <TextField
                  id="txt-purpose"
                  label="Purpose"
                  variant="outlined"
                  size="small"
                  fullWidth
                  multiline
                  minRows={2}
                  value={this.state.purpose}
                  onChange={e => this.setState({ purpose: e.target.value })}
                  disabled={this.isEditMode()}
               />
               {
                  !this.isEditMode() && <AttachmentInput
                     label="Quotation"
                     name={this.state.quotation?.name}
                     onChange={quotation => this.setState({ quotation })}
                  />
               }
            </div>
         </DialogContent>
         <DialogActions>
            <Button onClick={this.submit} variant="contained" size="small">
               Submit
            </Button>
         </DialogActions>
      </Dialog>
   }
}